<template>
  <div class="row row-cols-1 row-cols-md-4 g-3">
  <div class="col">
    <div class="card h-100">
      <img
        src="../assets/IMG_3338.jpeg"
        class="card-img-top"
        alt="..."
      />
      
    </div>
  </div>
  <div class="col">
    <div class="card h-100">
      <img
        src="../assets/IMG_3323.jpg"
        class="card-img-top"
        alt="..."
      />
      
    </div>
  </div>

  <div class="col">
    <div class="card h-100">
      <img
        src="../assets/IMGcrop_3362.jpeg"
        class="card-img-top"
        alt="..."
      />
      
    </div>
  </div>
  <div class="col">
    <div class="card h-100">
      <img
        src="../assets/Bathroom-cut.png"
        class="card-img-top"
        alt="..."
      />
       </div>
    </div>
      
     

  <div class="col">
    <div class="card h-100">
      <img
        src="../assets/IMG_3452.jpg"
        class="card-img-top"
        alt="..."
      />
      
    </div>
  </div>

  <div class="col">
    <div class="card h-100">
      <img
        src="../assets/IMG_3511.jpeg"
        class="card-img-top"
        alt="..."
      />
      
    </div>
  </div>

  <div class="col">
    <div class="card h-100">
      <img
        src="../assets/IMG_3468.jpg"
        class="card-img-top"
        alt="..."
      />
      
    </div>
  </div>

  <div class="col">
    <div class="card h-100">
      <img
        src="../assets/IMG_3477.jpg"
        class="card-img-top"
        alt="..."
      />
      
    </div>
  </div>

  <div class="col">
    <div class="card h-100">
      <img
        src="../assets/IMG_3665.jpeg"
        class="card-img-top"
        alt="..."
      />
      
    </div>
  </div>
  <div class="col">
    <div class="card h-100">
      <img
        src="../assets/IMG_3672.jpg"
        class="card-img-top"
        alt="..."
      />
      
    </div>
  </div>
  <div class="col">
    <div class="card h-100">
      <img
        src="../assets/IMG_3509.jpeg"
        class="card-img-top"
        alt="..."
      />
      
    </div>
  </div>
  <div class="col">
    <div class="card h-100">
      <img
        src="../assets/church paint cut.jpg"
        class="card-img-top"
        alt="..."
      />
     
    </div>
  </div>

<div class="col">
    <div class="card h-100">
      <img
        src="../assets/firststone.jpg"
        class="card-img-top"
        alt="..."
      />
     
    </div>
  </div>

  <div class="col">
    <div class="card h-100">
      <img
        src="../assets/IMG_3796.jpg"
        class="card-img-top"
        alt="..."
      />
     
    </div>
  </div>
 
 <div class="col">
    <div class="card h-100">
      <img
        src="../assets/IMG_3797.jpg"
        class="card-img-top"
        alt="..."
      />
     
    </div>
  </div>

<div class="col">
    <div class="card h-100">
      <img
        src="../assets/IMG_1202.jpg"
        class="card-img-top"
        alt="..."
      />
     
    </div>
  </div>

  <div class="col">
    <div class="card h-100">
      <img
        src="../assets/IMG_2479.jpg"
        class="card-img-top"
        alt="..."
      />
     
    </div>
  </div>

  

<div class="col">
    <div class="card h-100">
      <img
        src="../assets/IMG_2959.jpg"
        class="card-img-top"
        alt="..."
      />
     
    </div>
  </div>

 <div class="col">
    <div class="card h-100">
      <img
        src="../assets/IMG_2963.jpg"
        class="card-img-top"
        alt="..."
      />
     
    </div>
  </div>

   <div class="col">
    <div class="card h-100">
      <img
        src="../assets/IMGCeramic_0765.jpeg"
        class="card-img-top"
        alt="..."
      />
     
    </div>
  </div>

  <div class="col">
    <div class="card h-100">
      <img
        src="../assets/IMG2016.jpg"
        class="card-img-top"
        alt="..."
      />
     
    </div>
  </div>

<div class="col">
    <div class="card h-100">
      <img
        src="../assets/٢٠١٦٠٩٢٩_١٤٣١٥٧.jpg"
        class="card-img-top"
        alt="..."
      />
     
    </div>
  </div>

  <div class="col">
    <div class="card h-100">
      <img
        src="../assets/20161003_190543.jpg"
        class="card-img-top"
        alt="..."
      />
     
    </div>
  </div>

  <div class="col">
    <div class="card h-100">
      <img
        src="../assets/FB_IMG_1434717511864.jpg"
        class="card-img-top"
        alt="..."
      />
     
    </div>
  </div>

  

</div>
</template>

<script>
export default {

}
</script>

<style>

</style>